import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import PhoneContext from './PhoneContext'

const PhoneErrors = ({ validations, displayType = 'inline' }) => {
  const {
    phoneUnique,
    verificationStatus,
    errorMessage
  } = useContext(PhoneContext)

  const renderError = (message) => {
    if (displayType === 'alert') {
      return (
        <div role="alert" className="alert alert-danger">
          <p>{message}</p>
        </div>
      )
    }
    return <div className="text-danger mt-2">{message}</div>
  }

  return (
    <>
      {errorMessage && renderError(errorMessage)}
      {!errorMessage && verificationStatus === 'failed' && renderError(<FormattedMessage id="client.phone_verification.errors.incorrect_code" defaultMessage="Incorrect verification code. Please try again." />)}
      {validations === false && renderError(<FormattedMessage id="client.phone_verification.errors.invalid_format" defaultMessage="Please enter your phone number in the correct format." />)}
      {phoneUnique === false && renderError(<FormattedMessage id="client.phone_verification.errors.already_registered" defaultMessage="This phone number is already registered in our system. Please sign in." />)}
    </>
  )
}

export default PhoneErrors
